import { computed } from 'vue';
import { useProjectSettingStore } from '@/store/modules/projectSetting';
import { useUserStore } from '@/store/modules/user';

export function useProjectSetting() {
  const projectStore = useProjectSettingStore();
  const userStore = useUserStore();
  const isMobileDeployment = userStore.isMobileDeployment;

  // Use horizontal nav mode for mobile deployment
  const getNavMode = computed(() => (isMobileDeployment ? 'horizontal' : projectStore.navMode));

  const getNavTheme = computed(() => projectStore.navTheme);

  const getHeaderSetting = computed(() => projectStore.headerSetting);

  const getBodySetting = computed(() => projectStore.bodySetting);

  // Hide tabs for mobile deployment
  const getMultiTabsSetting = computed(() => {
    if (isMobileDeployment) {
      return { ...projectStore.multiTabsSetting, show: false };
    }
    return projectStore.multiTabsSetting;
  });

  // Auto-collapse menu for mobile deployment
  const getMenuSetting = computed(() => {
    if (isMobileDeployment) {
      return { ...projectStore.menuSetting, collapsed: true };
    }
    return projectStore.menuSetting;
  });

  // Hide breadcrumbs for mobile deployment
  const getCrumbsSetting = computed(() => {
    if (isMobileDeployment) {
      return { ...projectStore.crumbsSetting, show: false };
    }
    return projectStore.crumbsSetting;
  });

  const getPermissionMode = computed(() => projectStore.permissionMode);

  const getShowFooter = computed(() => projectStore.showFooter);

  const getIsPageAnimate = computed(() => projectStore.isPageAnimate);

  const getPageAnimateType = computed(() => projectStore.pageAnimateType);

  return {
    getNavMode,
    getNavTheme,
    getHeaderSetting,
    getBodySetting,
    getMultiTabsSetting,
    getMenuSetting,
    getCrumbsSetting,
    getPermissionMode,
    getShowFooter,
    getIsPageAnimate,
    getPageAnimateType,
  };
}
